<template>
  <v-card flat style="background-color:#e9e9e9;">
   
    <v-tabs  fixed-tabs elevation-0  style="background-color:#e9e9e9;">
      <v-tab @change="changetab('Media Job Type Master')">
        <v-icon left>
          mdi-bank
        </v-icon>
        Media Job Type Master
      </v-tab>

 <v-tab @change="changetab('Event + Job Type - Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Event + Job Type Mapping
      </v-tab>



       <v-tab @change="changetab('Event + Job Type - Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Job + Role Mapping
      </v-tab>

      <v-tab-item >
        <mediaJobtypemaster></mediaJobtypemaster>
      </v-tab-item>
     
     
       <v-tab-item style="background-color:#e9e9e9;">
       <EventMediaJobtypemerge></EventMediaJobtypemerge>
      </v-tab-item>
    
 <v-tab-item >
        <MediaJobRolemaping></MediaJobRolemaping>
      </v-tab-item>


     
      
    </v-tabs>
  </v-card>
</template>
<script>
import mediaJobtypemaster from '../../../components/MediaJobtypemaster'
import EventMediaJobtypemerge from '../../../components/EventMediajobtypemerge.vue'
import MediaJobRolemaping from '../masters/MediaJobRolemaping.vue'


export default {
 components: {mediaJobtypemaster,EventMediaJobtypemerge,MediaJobRolemaping},
  methods:{
    changetab: function(pagename) {
        this.$store.commit("setPageTitle", pagename);
    }
 }
  
}
</script>